import { Space } from "@bedrock/components";
import React, { ReactNode } from "react";
import CopyIcon from "./CopyIcon";

const CopyableNode = ({ value, children, affter, ...rest }: { value: any, children?: ReactNode, tipToolTitle?: string, affter?: ReactNode }) => {
  return (
    <Space size={0}>
      <div>{children || (value === undefined || value === '' ? '--' : value)}</div>
      {value && <CopyIcon text={value} style={{ margin: '0 0 0 4px', color: 'var(--text-color-3)', }} {...rest} />}
      {affter}
    </Space>
  )
}

export default CopyableNode;
